var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"btn",attrs:{"id":_vm.id,"aria-label":_vm.ariaLabel}},_vm.$listeners),[_vm._t("default",function(){return [_c('img',{attrs:{"src":_vm.src,"alt":"","width":"width","height":"height"}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }